import { UrlApi } from "../../../../services/apirest";

export const getPagosGeneral = async ( empresa, desde, hasta) => {
  try {
    const url = `${UrlApi}/envasado_pagos_combinados/generalpagos/${desde} 00:00:00/${hasta} 23:59:59/${empresa}`;
    
    const response = await fetch(url, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      }
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.message || `Error ${response.status}: ${response.statusText}`);
    }
    
    const data = await response.json();
    return data;
    
  } catch (error) {
    console.error('Error en getPagosDB:', error);
    throw error;
  }
};